import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

interface SidebarState {
  isCollapsed: boolean;
}

const initialState: SidebarState = {
  isCollapsed: isMobile,
};

const sidebarStateSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    setSidebarState: (state, action: PayloadAction<boolean>) => {
      state.isCollapsed = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarState } = sidebarStateSlice.actions;
export default sidebarStateSlice.reducer;
